'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
import React from 'react';
import { findClosestGlyphAvailable, Icon, IconSizeMap } from "../../index.mjs";

/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconEnhanceBadge/index.tsx)
 */
export function IconEnhanceBadge(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M1 0a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zm7.975 4.287c1.268-.448 1.959-1.448 2.288-2.318.042-.113.432-.113.474 0 .33.87 1.02 1.87 2.288 2.318.113.04.113.386 0 .426-1.268.448-1.959 1.448-2.288 2.319-.042.112-.432.112-.474 0-.33-.87-1.02-1.871-2.288-2.319-.113-.04-.113-.386 0-.426M1.893 9.33c2.347-.647 3.474-2.68 3.904-4.25.033-.118.373-.118.406 0 .43 1.57 1.557 3.603 3.904 4.25.115.032.115.308 0 .34-2.347.648-3.474 2.68-3.904 4.25-.033.118-.373.118-.406 0-.43-1.57-1.557-3.602-3.904-4.25-.115-.032-.115-.308 0-.34\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M3 1a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm11.975 5.302c1.268-.447 1.959-1.448 2.288-2.318.042-.113.432-.113.474 0 .33.87 1.02 1.871 2.288 2.318.113.04.113.387 0 .427-1.268.447-1.959 1.448-2.288 2.318-.042.113-.432.113-.474 0-.33-.87-1.02-1.87-2.288-2.318-.113-.04-.113-.386 0-.427M19.5 18a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M2.99 12.352C7.389 11.47 9.27 7.9 9.833 5.485c.027-.118.307-.118.334 0 .563 2.414 2.444 5.984 6.843 6.867.119.024.119.272 0 .296-4.4.883-6.28 4.454-6.843 6.867-.027.118-.307.118-.334 0-.563-2.413-2.444-5.984-6.843-6.867-.119-.024-.119-.272 0-.296\'/>'
  }];
  var iconSizeValue = props.size ? IconSizeMap[props.size] : props.iconSize;
  var closestSize = findClosestGlyphAvailable(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}